import api from '../api'

export const getProductsQuotationByOrg = (params, { organizationId }) =>
  api.get(`/v1/products-quotation/organization/${ organizationId }`, { params })

export const getAllProductsQuotationByUser = (params) =>
  api.get('/v1/products-quotation/organizations/user', { params })
